import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { WorldIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'

import { createCountry } from '../../api/countries/create-country'
import UserNavBar from '../../components/elements/nav-bar'
import CountryForm from '../../components/pages/countries/country-form'
import { Paths } from '../../lib/constants/path'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const CountryCreatePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createCountry,
    onError: showAxiosError
  })

  return (
    <div>
      <UserNavBar title={'Créer un pays'} icon={WorldIcon} />
      <div className={'h-4'} />

      <Box>
        <CountryForm
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await mutateAsync(values)
              navigate(Paths.COUNTRY_UPDATE_PAGE.replace(':id', res.id.toString()), {
                replace: true
              })
            },
            onCancel: () => back(Paths.COUNTRY_LIST_PAGE)
          })}
        />
      </Box>
    </div>
  )
}

export default CountryCreatePage
